export const server= "https://saptravels-backend-ls.vercel.app"
